import MediaAssets from "assets";
import { useState, useEffect } from "react";
import styles from "./Landing.module.css";
// import OnGoingBanner from "./ongoing-banner/OnGoingBanner";
import PopularBlogs from "./popular-blogs/popular-blogs";
import TestimonialCarousel from "./testimonial-carousel/TestimonialCarousel";
import MenuAccordion from "./menu-accordion/MenuAccordion";
// import InvestWithUs from "./invest-with-us/InvestWithUs";
// import DownloadApp from "./download-app/DownloadApp";
import LandingFooter from "./landing-footer/LandingFooter";
import Project from "./projects/projects";
// import UpComingBanner from "./upcoming-banner/UpComingBanner";
import Menu from "pages/menu/Menu";
import { getPreLoginPageAction } from "redux-container/pre-login-page-management-redux/PreLoginPageManagementRedux";
import { PageSeoAction } from "redux-container/page-seo/PageSeo";
import { PageTypeEnum } from "enumerations/PageTypeEnum";
import { useDispatch, useSelector } from "react-redux";
import UniVersialSearchModal from "./universial-search-modal/UniVersialSearchModal";
import { getItemFromLocalStorage } from "utils/LocalStorageUtils";
import { Constants } from "constants/Constants";
import { getPagesRequest } from "redux-container/page-management-redux/PageManagementRedux";
import { NewLaunchActions } from "redux-container/investments/new-launch/NewLaunchRedux";
import WebProfileHeader from "components/web-profile-header/WebProfileHeader";
import MobileProfileHeader from "components/mobile-profile-header/MobileProfileHeader";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import { Helmet } from "react-helmet";
import SoldoutProjects from "./soldout-projects/SoldoutProjects";
import FastSelling from "./fast-selling/FastSelling";
import CommingSoonProjects from "./comming-soon/CommingSoonProjects";
import ReactPlayer from "react-player";
// import AyodhyaPop from "./AyodhyaPopUp/PopUp";
import { PageOneActions } from "redux-container/page1data-get-redux/getPage1data";

const actionDispatch = (dispatch: any) => {
  return {
    getPreLoginPageDetails: (params: any) =>
      dispatch(getPreLoginPageAction.getPreLoginPagesRequest(params)),
    // PageSeoAction
    getPreLoginPageSeoDetails: (params: any) => {
      dispatch(PageSeoAction.getPageSeoDataRequest(params));
    },

    getProjectContentList: (params: any) =>
      dispatch(getPreLoginPageAction.getProjectContentsRequest(params)),
    setPagemanagementState: (key: any, value: any) =>
      dispatch(getPreLoginPageAction.setPageState(key, value)),
    getAllInvestments: () =>
      dispatch(NewLaunchActions.getAllInvestmentsRequest()),
    getNewLaunchData: (params: any) =>
      dispatch(NewLaunchActions.getNewLaunchRequest(params)),

    getPageOneData: (params: any) =>
      dispatch(PageOneActions.getPageOneDataRequest(params)),
  };
};

const Landing = () => {
  const [bcColor, setBcColor] = useState<boolean>(true);
  const [isCentered, setIsCentered] = useState<boolean>(true);
  const [chevronStyle, setChevronStyle] = useState<boolean>(false);
  const [hamburgerDiv, setHamburgerDiv] = useState<boolean>(false);
  const [chevronDiv, setChevronDiv] = useState<boolean>(false);
  const [animationLogo, setAnimationLogo] = useState<boolean>(false);
  const [bcStartColor, setBcStartColor] = useState<boolean>(true);
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const [searchIcon, setSearchIcon] = useState<boolean>(false);
  const [showImg, setshowImg] = useState(false);
  const [showUniSaechModal, setShowUniSaechModal] = useState<boolean>(false);
  //CODE CAN BE USED FOR FUTURE AD POPUP
  // const [showPopup, setShowPopup] = useState(true); // to close ayodhya pop up
  // const closePopup = () => {
  //   setShowPopup(!showPopup);
  // };

  const {
    getPreLoginPageDetails,
    getAllInvestments,
    getNewLaunchData,
    getPreLoginPageSeoDetails,
    getPageOneData,
  } = actionDispatch(useDispatch());

  const { pathname } = useLocation();

  //Brand video accessing from page1 data .
  const brandVideoArray = useSelector(
    (state: any) => state?.pageOneData?.pageOneData?.page?.brandMedia
  );
  // console.log("brandVideoArray", brandVideoArray);

  // useEffect(() => {
  //   getPageOneData("5001");
  // }, []);

  const getInitialLayout = () => {
    setTimeout(() => {
      setIsCentered(!isCentered);
      setChevronDiv(!chevronDiv);
      setHamburgerDiv(!hamburgerDiv);
      setAnimationLogo(!animationLogo);
      setBcStartColor(!bcStartColor);
      setSearchIcon(!searchIcon);
    }, 2000);
    setTimeout(() => {
      setBcColor(!bcColor);
      setChevronStyle(!chevronStyle);
    }, 3000);
    setTimeout(() => {
      setshowImg(true);
    }, 4000);
  };
  const getInitialData = () => {
    const token = getItemFromLocalStorage(Constants.AUTHORIZATION_TOKEN);
    getPreLoginPageSeoDetails(pathname);
    if (token) {
      const pageType = PageTypeEnum?.HoABL;
      const pageType3 = PageTypeEnum?.Investments;
      getPagesRequest(pageType);
      getPagesRequest(pageType3);
      getNewLaunchData(pageType);
      getNewLaunchData(pageType3);
    } else {
      const pageType = PageTypeEnum?.HoABL;
      const pageType3 = PageTypeEnum?.Investments;
      getPreLoginPageDetails(pageType);
      getPreLoginPageDetails(pageType3);
      getNewLaunchData(pageType);
      getNewLaunchData(pageType3);
    }
  };
  useEffect(() => {
    getInitialData();
    getInitialLayout();
    getAllInvestments();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
      <Helmet>
        <title>
          The House of Abhinandan Lodha | India's Largest Branded Land Developer
        </title>
        <meta
          name="title"
          content="The House of Abhinandan Lodha | India's Largest Branded Land Developer"
        />
        <meta
          name="description"
          content="The House of Abhinandan Lodha: democratizing land through technology, creating secure investment opportunities for intergenerational wealth."
        />
        <meta
          name="keywords"
          content="House of abhinandan lodha, Hoabl, Abhinandan Lodha Group,  Tomorrow Land, TomorrowView, Cape of Bliss, Tomorrow World, Imperial Goa, Land in Anjarle, Land in Dapoli, Plots in Anjarle, Land Developer in Mumbai, Land Investment in India, Land investment companies"
        />
        <meta
          property="og:title"
          content="The House of Abhinandan Lodha | India's Largest Branded Land Developer"
        />
        <meta
          property="og:description"
          content="The House of Abhinandan Lodha: democratizing land through technology, creating secure investment opportunities for intergenerational wealth."
        />
        <meta
          property="og:keywords"
          content="House of abhinandan lodha, Hoabl, Abhinandan Lodha Group,  Tomorrow Land, TomorrowView, Cape of Bliss, Tomorrow World, Imperial Goa, Land in Anjarle, Land in Dapoli, Plots in Anjarle, Land Developer in Mumbai, Land Investment in India, Land investment companies"
        />
        <meta
          name="twitter:title"
          content="The House of Abhinandan Lodha | India's Largest Branded Land Developer"
        />
        <meta
          name="twitter:description"
          content="The House of Abhinandan Lodha: democratizing land through technology, creating secure investment opportunities for intergenerational wealth."
        />
        <meta
          name="twitter:keywords"
          content="House of abhinandan lodha, Hoabl, Abhinandan Lodha Group,  Tomorrow Land, TomorrowView, Cape of Bliss, Tomorrow World, Imperial Goa, Land in Anjarle, Land in Dapoli, Plots in Anjarle, Land Developer in Mumbai, Land Investment in India, Land investment companies"
        />
      </Helmet>

      <>
        <div style={{ overflowX: "hidden" }}>
          {showUniSaechModal && (
            <>
              <div className={styles.uniSearchCon}>
                <UniVersialSearchModal closeModal={setShowUniSaechModal} />
              </div>
            </>
          )}
          {showMenu ? (
            <Menu setShowMenu={setShowMenu} />
          ) : (
            <>
              {/* CODE CAN BE USED FOR OPENING POPUP FOR FUTURE AD */}
              {/*<showPopup && <AyodhyaPop onClose={closePopup} /> */}
              <div style={{ background: "rgba(24, 36, 40, 1" }}>
                <div className={styles.home_container}>
                  <div className={styles.desktopMenu}>
                    <WebProfileHeader
                      backgroundColor="#000000"
                      middleDetails={true}
                      contentColor="white"
                      inputDivBackgroundColor="rgba(255, 255, 255, 0.16)"
                      inputDivBorder="none"
                      inputBackGroundColor="transparent"
                      inputBorder="none"
                      inputBoxShadow="none"
                      inputOutline="none"
                      inputImg={MediaAssets.input_gray_icon}
                      websiteLogo={MediaAssets.white_logo}
                      inputPlaceHolderColor="#FFFFFF"
                      stickyBackgroundColor="#000000"
                    />
                  </div>
                  {/* end of desktop menu */}
                  <div className={styles.mobileMenu}>
                    <MobileProfileHeader
                      mobileHobalImg={MediaAssets.content_img}
                      MobileSearchIcon={MediaAssets.search_icon}
                      MobileHamBurgerIcon={MediaAssets.hamburger_menu}
                      setShowMenu={setShowMenu}
                      MobileHeaderBackGroundColor="transparent"
                      MobileStickyHeaderBackGroundColor="transparent"
                      MobileHeaderPosition="absolute"
                      MobileHeaderStickyPosition="fixed"
                    />
                  </div>

                  <div
                    className={bcStartColor ? styles.home_start_wrapper : ""}
                  ></div>
                  <div className={bcColor ? styles.home_wrapper : ""}></div>
                  <div className={styles.videoCon}>
                    <div className={styles.forDesktopVideo}>
                      <ReactPlayer
                        // url={MediaAssets.web_video}
                        url={brandVideoArray?.[0]?.webMedia?.value?.url}
                        className={styles["react-player"]}
                        width="100%"
                        height={"100%"}
                        playsinline
                        playing
                        muted
                        loop={true}
                        config={{
                          file: {
                            attributes: {
                              autoPlay: true,
                              muted: true,
                            },
                          },
                        }}
                      />
                    </div>
                    <div className={styles.forMobileVideo}>
                      <ReactPlayer
                        // url={MediaAssets.mobile_video}
                        url={brandVideoArray?.[0]?.mobileMedia?.value?.url}
                        className={styles["react-player"]}
                        width="100vw"
                        height={"100%"}
                        playsinline
                        playing
                        muted
                        loop={true}
                        config={{
                          file: {
                            attributes: {
                              autoPlay: true,
                              muted: true,
                            },
                          },
                        }}
                      />
                    </div>
                  </div>

                  {/* animated */}
                  {!showImg && (
                    <>
                      <div
                        className={`${styles.content_img_style} ${
                          isCentered ? styles.center : styles.top
                        }`}
                        style={{ transition: "all 2s ease" }}
                      >
                        <div
                          className={
                            animationLogo
                              ? styles.animate_none
                              : styles.animation_logo
                          }
                        ></div>

                        <img src={MediaAssets.content_img} alt="Landing page" />
                      </div>
                    </>
                  )}
                </div>

                <MenuAccordion />
              </div>
              <div className={styles.onCommingCon}>
                <FastSelling />
        <div className={styles.cardBackground}>
        <div className={styles.card}>
  <h2>Disclaimer</h2>
  <p>
    {/* The House of Abhinandan Lodha® is an independent real estate consumer-tech brand. 
    We have no association with Macrotech Developers Limited or any of its subsidiaries, 
    affiliates or associate companies. */}
    ‘House of Abhinandan Lodha’ has been established in 2020 and is not, in any manner, associated with ‘Lodha’ or ‘Lodha Group’.
  </p>
</div>
        </div>

                <CommingSoonProjects showHeader={true} />
                <SoldoutProjects />
              </div>
              <TestimonialCarousel />
              <PopularBlogs />
              <div style={{ background: "black" }}></div>
              <div style={{}}>
                <LandingFooter />
                <Project />
              </div>
            </>
          )}
        </div>
      </>
    </>
  );
};
//added comment line just for testing.
export default Landing;
